import styled from "styled-components";

const WeightSelectorBundle = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  flex: 1;

  &.large-weight {
    max-width: 188px;
  }

  .weight-selector__weight {
    padding: .5rem 16px .5rem 0;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    position: relative;
    background-color: ${({theme}) => theme.colors.bundleBlack};
    color: ${({theme}) => theme.colors.bundleWhite};
    outline: none;
    line-height: 1;
    transition: var(--button-transition);
    font-size: 30px;
    font-family: var(--font-DINNextLTPro-Regular);

    &.is-active {
      color: ${({theme}) => theme.colors.brandDark};
    }

    &:hover,
    &:focus {
      .weight-selector__radio {
        border-color: ${({theme}) => theme.colors.brandDark};
      }
      color: ${({theme}) => theme.colors.brandDark};
    }
  }

  .weight-selector__copy {
    color: ${({theme}) => theme.colors.brandDark};
  }

  .weight-selector__radio {
    margin-right: 6px;
    margin-bottom: 4px;
    position: relative;
    height: 25px;
    width: 25px;
    background-color: transparent;
    border: 2px solid ${({theme}) => theme.colors.gray3};
    border-radius: 50%;
    flex-shrink: 0;
    transition: var(--button-transition);

    &.is-active {
      background-color: ${({theme}) => theme.colors.brandDark};
      border-color: ${({theme}) => theme.colors.brandDark};
    }
  }
`;

export default WeightSelectorBundle;